import React, { Fragment } from "react";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Row,
	Col,
	FormGroup,
	Label,
	Input
} from "reactstrap";
import Datetime from "react-datetime";
import moment from "moment";
import Async from 'react-select/async';
// Requests
import { getClientRequest, createClientRequest, updateClientRequest } from "../../api/client";
import { getSellersRequest } from "../../api/seller";
import { getProjectsRequest } from "api/project";
import { getProjectRequest } from "api/project";
// Helpers
import { getFormattedDate } from "helpers/date";
import { formatPrice } from "helpers/pricing";
// Components
import CurrencyInput from "components/CurrencyInput/CurrencyInput";
// Contexts
import ProjectContext from "contexts/ProjectContext";

class ClientForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			client: null,
			error: null,
			saving: false,
			filtersSellers: {},
			filtersProjects: {},
			filtersUnits: {},
			units: [],
			projectPermission: false,
			projectModels: [],
			priceModel: 0
		}
	}

	static contextType = ProjectContext
	
	async componentDidMount() {
		this.previousContext = this.context
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');
		const { selectedProject } = this.context

		if(selectedProject) {
            this.handleDefaultProject(selectedProject)
        }

		if (id) {
			try {
				const client = await getClientRequest(id);

				if(client.seller) {
					client.selectedSeller = {
						label: `${client.seller.first_name} ${client.seller.last_name}`,
						value: client.seller._id
					};
				}
				if(client.project) {
					client.selectedProject = {
						label: `${client.project.name}`,
						value: client.project._id
					};
				}
				if (client.unit) {
					client.selectedUnit = {
						label: `Block ${client.unit.block_number } - Lot ${client.unit.lot_number}`,
						value: client.unit._id
					};
				}

				this.setState({ client })
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching client'
				});
			}
		} else {
			// case for adding a client
			this.setState({
				client: {
					name: '',
				}
			})
		}
	}

	async componentDidUpdate() {
        const { selectedProject } = this.context;
        
        if(this.previousContext.selectedProject !== selectedProject) {
            if(this.previousContext.selectedProject) {
                window.location.reload()
            }

			this.previousContext.selectedProject = selectedProject
            if(selectedProject) {
                this.handleDefaultProject(selectedProject)
            }

        }
    }

	handleDefaultProject = async (selectedProject) => {
        const project = await getProjectRequest(selectedProject)

    
        this.setState(prevState => ({
            client: {
				...prevState.client,
                project: project,
				selectedProject: {
					label: `${project.name}`,
					value: project._id
				}
			}
		}))
	}
           

	goTo = path => this.props.history.push(path);

	onChangeField = (e) => {
		const { target } = e;
		const { name, value } = target;

		if (name === "selling_price") {

			const discountApplied = this.state.client.discount || 0;

			const netSellingPrice = Number(value) - Number(discountApplied);

			const vatCalculated = netSellingPrice * 0.12;

			const tcpCalculated = netSellingPrice + vatCalculated

			this.setState(prevState => ({
				client: {
					...prevState.client,
					[name]: value,
					discount: discountApplied,
					net_selling_price: netSellingPrice,
					vat: vatCalculated,
					tcp: tcpCalculated
				},
			}));

		} else if (name === "discount" && this.state.client.selling_price) {

			const discountApplied = value;

			const netSellingPrice = Number(this.state.client.selling_price) - Number(discountApplied);

			const vatCalculated = netSellingPrice * 0.12;

			const tcpCalculated = netSellingPrice + vatCalculated

			this.setState(prevState => ({
				client: {
					...prevState.client,
					[name]: value,
					discount: discountApplied,
					net_selling_price: netSellingPrice,
					vat: vatCalculated,
					tcp: tcpCalculated
				},
			}));

		} else {
			this.setState(prevState => ({
				client: {
					...prevState.client,
					[name]: value,
				},
			}));
		}

		
	}

	onSelectChange = (key) => (object) => {
		this.setState(prevState => ({
			client: {
				...prevState.client,
				[key]: object,
			},
		}));
	}

	changingContractValuesAuto = () => {
		const { selling_price, discount } = this.state.client;
		const { tcpModel } = this.state;

		if(selling_price && discount) {
			const netSellingPrice = selling_price - discount;

			const tcp = tcpModel + netSellingPrice
			this.setState((prevState) => ({
				client: {
					...prevState.client,
					net_selling_price: netSellingPrice,
					tcp
				}
			}));
			
		}

	}

	onChangeCheckbox = (e) => {
		const { target } = e;
		const { name, checked } = target;

		if (name === "zero_vat") {
			
			const netSellingPrice = Number(this.state.client.net_selling_price);

			const vatCalculated = checked ? 0 : netSellingPrice * 0.12;

			const tcpCalculated = netSellingPrice + vatCalculated

			this.setState(prevState => ({
				client: {
					...prevState.client,
					[name]: checked,
					vat: vatCalculated,
					tcp: tcpCalculated
				},
			}));

		} else {
			this.setState(prevState => ({
				client: {
					...prevState.client,
					[name]: checked,
				},
			}));
		}

		
	}

	save = async () => {
		const { client } = this.state;
		this.setState({
			saving: true
		})
		
		const { _id } = client;
		
		client.total = this.calculateTotalIncome();
		
		if (client.selectedProject) {
			client.project = client.selectedProject.value
		}
		
		try {
			if (_id) {
				await updateClientRequest(client);
			} else {
				await createClientRequest(client);
			}
			this.setState({
				saving: false
			})
			this.goTo('/clients');
		} catch (err) {
			console.log(err, "error");
			this.setState({
				error: err.message || 'There was an error saving client',
				saving: false
			})
		}
	}

	onChangeSpouseField = (e) => {
		const { target } = e;
		const { name, value } = target;
		this.setState(prevState => ({
			client: {
				...prevState.client,
				spouseOccupation: {
					...prevState.client.spouseOccupation,
					[name]: value
				},
			},
		}));
	}

	onChangeCoBorrowerField = (key, index) => (e) => {
		const { target } = e;
		const { name, value } = target;
		const { coBorrowers=[] } = this.state.client;

		const updatedCoBorrowers = [...coBorrowers];
		if(key === 'coBorrower') {
			updatedCoBorrowers[index] = {
				...updatedCoBorrowers[index],
				[name]: value
			}
		} else {
			updatedCoBorrowers[index] = {
				...updatedCoBorrowers[index],
				[key]: {
					...updatedCoBorrowers[index][key],
					[name]: value
				}
			}
		}
		this.setState((prevState) => ({
			client: {
				...prevState.client,
				coBorrowers: updatedCoBorrowers
			}
		}));
	}

	addDependent = () => {
		const { dependents=[] } = this.state.client;
		this.setState((prevState) => ({
			client: {
				...prevState.client,
				dependents: [
					...dependents,
					{
						name: '',
						birthday: null,
						age: '',
						relation: ''
					}
				]
			}
		}));
	}

	handleDependentChange = (index) => (event) => {
		const { name, value } = event.target;
		const { dependents } = this.state.client;
		const updatedDependents = [...dependents];
		updatedDependents[index] = {
			...updatedDependents[index],
			[name]: value
		}
		this.setState((prevState) => ({
			client: {
				...prevState.client,
				dependents: updatedDependents
			}
		}));
	}

	deleteDependent = (dependentIndex) => () => {
		const { dependents=[] } = this.state.client;
		const updatedDependents = [...dependents];
		updatedDependents.splice(dependentIndex, 1);
		this.setState((prevState) => ({
			client: {
				...prevState.client,
				dependents: updatedDependents
			}
		}));
	}

	loadSellers = async (search, callback) => {
		const { filtersSellers } = this.state;

		const updatedFilters = {
			...filtersSellers,
			search
		}

		this.setState({
			filtersSellers: updatedFilters
		});
		if(search) {
			const sellerResponse = await getSellersRequest(updatedFilters);
			const sellers = sellerResponse.sellers.map(seller => {
				return {
					data: seller,
					label: `${seller.first_name} ${seller.last_name} ${seller.broker ? `(${seller.broker.name})` : ''}`,
					value: seller._id
				}
			});
			callback(sellers);
		}
	}
	loadProjects = async (search, callback) => {
		const { filtersProjects } = this.state;
		const updatedFilters = {
			...filtersProjects,
			search
		}
		this.setState({
			filtersProjects: updatedFilters
		});
		if(search) {
			const projectObj = await getProjectsRequest(updatedFilters);
			const projects = projectObj.projects.map(project => {
				return {
					data: project,
					label: `${project.name}`,
					value: project._id
				}
			})
			callback(projects);
		}
	}

	calculateTotalIncome = () => {
		const {
			salary,
			spouseSalary,
			coBorrowerSalary,
			overtime,
			allowances,
			otherIncome
		} = this.state.client;
		const incomes = [salary, spouseSalary, coBorrowerSalary, overtime, allowances, otherIncome].filter(item => !!Number(item));
		const totalIncome = incomes.length ? incomes.reduce((item1, item2) => Number(item1)+Number(item2)) : 0;
		return totalIncome;
	}

	addCoBorrower = () => {
		const { coBorrowers=[] } = this.state.client;
		if(coBorrowers.length < 4) {
			this.setState((prevState) => ({
				client: {
					...prevState.client,
					coBorrowers: [
						...coBorrowers,
						{
							coBorrower: {
							  first_name: null,
							  last_name: null,
							  middle_name: null,
							  age: null,
							  gender: null,
							  birthday: null,
							  nationality: null,
							  email: null,
							  phone: null,
							  address: null,
							},
							coBorrowerOccupation: {
							  occupation: null,
							  companyName: null,
							  companyAddress: null,
							  companyContact: null,
							  companyEmail: null,
							  businessNature: null,
							  jobTitle: null,
							  experience: null,
							}
						}
					]
				}
			}));
		}
	}

	deleteCoborrower = (coBorrowerIndex) => () => {
		const { coBorrowers=[] } = this.state.client;
		const updatedCoBorrowers = [...coBorrowers];
		updatedCoBorrowers.splice(coBorrowerIndex, 1);
		this.setState((prevState) => ({
			client: {
				...prevState.client,
				coBorrowers: updatedCoBorrowers
			}
		}));
	}

	render() {

		const {
			client = {},
			error = null,
			saving
		} = this.state;
		
		const {
			_id,
			first_name,
			last_name,
			middle_name,
			civil_status,
			age,
			gender,
			birthday,
			nationality,
			tin,
			email,
			phone,
			status,
			refund_amount,
			home_owner,
			owned_date,
			spouseOccupation,
			salary,
			spouseSalary,
			coBorrowerSalary,
			hasCoBorrower,
			coBorrowers=[],
			overtime,
			allowances,
			otherIncome,
			spouse = {},
			attorneyInFact,
			attorney={},
			dependents=[],
            address,
			created_at,
			updated_at,
			selectedSeller = [],
			selectedProject = [],
			selectedUnit = [],
			is_rto,
			financingType,
			financingSubtype
		} = client || {};

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
									<CardTitle tag="h3">
										Client
                  					</CardTitle>
									<Button
										className="float-right"
										color="default"
										onClick={() => this.goTo('/clients')}
									>
										Back
                  					</Button>
								</CardHeader>
								<CardBody>
									{!client
										? <div>Loading...</div>
										: <>
											<Card className="detail-card">
												<CardHeader>
													<h3>Personal Information</h3>
												</CardHeader>
												<CardBody>
													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>First Name <span className="required-start">*</span></Label>
																<Input
																	type="text"
																	name="first_name"
																	value={first_name || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Last Name <span className="required-start">*</span></Label>
																<Input
																	type="text"
																	name="last_name"
																	value={last_name || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
													</Row>

													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Middle Name</Label>
																<Input
																	type="text"
																	name="middle_name"
																	value={middle_name || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Civil Status</Label>
																<Input
																	type="select"
																	name="civil_status"
																	value={civil_status || ''}
																	className={civil_status ? "" : ' select__placeholder'}
																	onChange={this.onChangeField}
																>
																	<option value=''>--SELECT--</option>
																	<option value='Single'>Single</option>
																	<option value='Married'>Married</option>
																	<option value='Widow/Legally Separated'>Widow/Legally Separated</option>
																</Input>
															</FormGroup>
														</Col>
													</Row>
													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Age</Label>
																<Input
																	type="text"
																	name="age"
																	value={age || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Gender</Label>
																<Input
																	type="select"
																	className={gender ? "" : ' select__placeholder'}
																	name="gender"
																	value={gender || ''}
																	onChange={this.onChangeField}
																>
																	<option value=''>--SELECT--</option>
																	<option value='Male'>Male</option>
																	<option value='Female'>Female</option>
																</Input>
															</FormGroup>
														</Col>
													</Row>

													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Birthday</Label>
																<Datetime
																	inputProps={{
																		className: "form-control",
																		placeholder: "Birthday",
																		name: "birthday"
																	}}
																	dateFormat="MM/DD/YYYY"
																	timeFormat={false}
																	value={typeof birthday === 'string' ? moment(birthday).format("MM/DD/YYYY") : birthday}
																	onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "birthday" }})}
																	closeOnSelect={true}
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Nationality</Label>
																<Input
																	type="text"
																	name="nationality"
																	value={nationality || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
													</Row>

													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>TIN</Label>
																<Input
																	type="text"
																	name="tin"
																	value={tin || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Home Address</Label>
																<Input
																	type="text"
																	name="address"
																	value={address || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
													</Row>

													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Email Address <span className="required-start">*</span></Label>
																<Input
																	type="text"
																	name="email"
																	value={email || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Contact Numbers/Mobile <span className="required-start">*</span></Label>
																<Input
																	type="text"
																	name="phone"
																	value={phone || ''}
																	onChange={this.onChangeField}
																/>
															</FormGroup>
														</Col>
													</Row>
												</CardBody>
											</Card>
											<WorkAndOccupationCard 
												title="Work and Occupation"
												onChangeField={this.onChangeField}
												data={client}
											/>
											<Card className="detail-card">
												<CardHeader>
													<h3>Financial Information</h3>
												</CardHeader>
												<CardBody>
													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Basic Monthly Salary</Label>
																<CurrencyInput 
																	name="salary"
																	price={salary || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "salary", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col>
														{civil_status === 'Married' ? <Col sm={12} md={6}>
															<FormGroup>
																<Label>Spouse Monthly Salary</Label>
																<CurrencyInput 
																	name="spouseSalary"
																	price={spouseSalary || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "spouseSalary", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col> : null}
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Co-Borrower Monthly Salary</Label>
																<CurrencyInput 
																	name="coBorrowerSalary"
																	price={coBorrowerSalary || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "coBorrowerSalary", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Overtime</Label>
																<CurrencyInput 
																	name="overtime"
																	price={overtime || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "overtime", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col>
													</Row>
													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Allowances</Label>
																<CurrencyInput 
																	name="allowances"
																	price={allowances || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "allowances", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Others</Label>
																<CurrencyInput 
																	name="otherIncome"
																	price={otherIncome || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "otherIncome", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col>
													</Row>
													<Row>
														<Col sm={12} md={6}>
															<FormGroup>
																<Label>Total</Label>
																<CurrencyInput 
																	readOnly
																	name="total"
																	price={this.calculateTotalIncome() || 0}
																	onChange={(value) => this.onChangeField({ target: { name: "total", value } })}
																	placeholder=""
																/>
															</FormGroup>
														</Col>
													</Row>
												</CardBody>
											</Card>
											<Card className="detail-card">
												<CardHeader>
													<h3>Dependents <i role="button" onClick={this.addDependent} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
												</CardHeader>
												<CardBody>
													<FormGroup>
														{
															dependents.map((dependent, index) => {
																return <Fragment key={index}>
																	<h5>Dependent #{index + 1}</h5>
																	<Row className="my-3">
																		<Col sm={5}>
																			<Input
																				type="text"
																				name="name"
																				placeholder="Name"
																				value={dependent.name}
																				onChange={this.handleDependentChange(index)}
																			/>
																		</Col>
																		<Col sm={5}>
																			<Datetime
																				inputProps={{
																					className: "form-control",
																					placeholder: "Birthday",
																					name: "birthday"
																				}}
																				dateFormat="MM/DD/YYYY"
																				timeFormat={false}
																				value={typeof dependent.birthday === 'string' ? moment(dependent.birthday).format("MM/DD/YYYY") : dependent.birthday}
																				onChange={(date) => this.handleDependentChange(index)({target: { value: moment(date).format("MM/DD/YYYY"), name: "birthday" }})}
																				closeOnSelect={true}
																			/>
																		</Col>
																	</Row>
																	<Row className="my-3">
																		<Col sm={5}>
																			<Input
																				type="text"
																				name="age"
																				placeholder="Age"
																				value={dependent.age}
																				onChange={this.handleDependentChange(index)}
																			/>
																		</Col>
																		<Col sm={5}>
																			<Input
																				type="text"
																				name="relation"
																				placeholder="Relation"
																				value={dependent.relation}
																				onChange={this.handleDependentChange(index)}
																			/>
																		</Col>
																		<Col className="d-flex align-items-center" sm={2}>
																			<i onClick={this.deleteDependent(index)} className="tim-icons icon-trash-simple cursor-pointer" />
																		</Col>
																	</Row>
																</Fragment>
															})
														}
													</FormGroup>
												</CardBody>
											</Card>
											<Card className='detail-card'>
												<CardHeader>
													<h3>{!_id ? "Project" : "Project & Contract"}</h3>
												</CardHeader>
												<CardBody>
													<Row>
														<Col sm={12}>
															<FormGroup>
																<Label>Project <span className="required-start">*</span></Label>
																<Async
																	value={selectedProject}
																	name="selectedProject"
																	options={[]}
																	loadOptions={this.loadProjects}
																	className="basic-multi-select"
																	classNamePrefix="select"
																	placeholder="Search project by name"
																	isDisabled
																/>
															</FormGroup>
														</Col>
														{_id ? 
															<>
																<Col sm={12} className="mb-4">
																	<FormGroup>
																		<Label>Unit</Label>
																		<Async
																			value={selectedUnit}
																			name="selectedUnit"
																			options={[]}
																			className="basic-multi-select"
																			classNamePrefix="select"
																			placeholder="N/A"
																			isDisabled
																		/>
																	</FormGroup>
																</Col>
																<Col sm={6}>
																<div className="typography-line">
																	<h4>
																		<span>Model</span>
																		{client.unit?.selectedModel?.name || "N/A"}
																	</h4>
																</div>

																<div className="typography-line">
																	<h4>
																		<span>Model Price</span>
																		{client.unit?.selectedModel?.price
																			? `PHP ${formatPrice(client.unit?.selectedModel?.price)}`
																			: "N/A"}
																	</h4>
																</div>
																<div className="typography-line">
																	<h4>
																		<span>Discount</span>
																		{client.unit?.selectedModel?.discount
																			? `PHP ${formatPrice(client.unit?.selectedModel?.discount)}`
																			: "N/A"}
																	</h4>
																</div>
																<div className="typography-line">
																	<h4>
																		<span>Discount Details</span>
																		{client.unit?.selectedModel?.discountDetails || "N/A"}
																	</h4>
																</div>
																</Col>
																<Col sm={6}>
																<div className="typography-line">
																	<h4>
																		<span>Net Selling Price</span>
																		{client.unit?.selectedModel?.price
																			? `PHP ${formatPrice(client.unit?.selectedModel?.price - (client.unit?.selectedModel?.discount || 0))}`
																			: "N/A"}
																	</h4>
																</div>
																<div className="typography-line">
																	<h4>
																		<span>VAT</span>
																		{client.unit?.selectedModel?.vat
																			? `PHP ${formatPrice(client.unit?.selectedModel?.vat)}`
																			: "N/A"}
																	</h4>
																</div>
																<div className="typography-line">
																	<h4>
																		<span>TCP</span>
																		{client.unit?.selectedModel?.tcp
																			? `PHP ${formatPrice(client.unit?.selectedModel?.tcp)}`
																			: "N/A"}
																	</h4>
																</div>
																</Col>
															</>
															: null
														}
													</Row>
												</CardBody>
											</Card>
											<FormGroup check className="text-left mb-3">
												<Label>
													Home Owner
												</Label>
												<Input
													type="select"
													name="home_owner"
													value={home_owner || ''}
													className={home_owner ? "" : ' select__placeholder'}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value='Yes'>Yes</option>
													<option value='No'>No</option>
												</Input>
											</FormGroup>
											{
												home_owner === 'Yes' ? <FormGroup>
													<Label>Owned Date</Label>
													<Datetime
														inputProps={{
															className: "form-control",
															placeholder: "Owned Date",
															name: "owned_date"
														}}
														dateFormat="MM/DD/YYYY"
														timeFormat={false}
														value={typeof owned_date === 'string' ? moment(owned_date).format("MM/DD/YYYY") : owned_date}
														onChange={(date) => this.onChangeField({target: { value: moment(date).format("MM/DD/YYYY"), name: "owned_date" }})}
														closeOnSelect={true}
													/>
												</FormGroup> : null
											}
											<FormGroup check className="text-left mb-3">
												<Label>
													RTO Client
												</Label>
												<Input
													type="select"
													name="is_rto"
													className={is_rto ? "" : ' select__placeholder'}
													value={is_rto || ''}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value={true}>Yes</option>
													<option value={false}>No</option>
												</Input>
											</FormGroup>
											<FormGroup check className="text-left mb-3">
												<Label>
													Financing Type
												</Label>
												<Input
													type="select"
													name="financingType"
													className={financingType ? "" : ' select__placeholder'}
													value={financingType || ''}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value={"bank"}>Bank</option>
													<option value={"pagIbig"}>Pag-ibig</option>
												</Input>
											</FormGroup>
											<FormGroup check className="text-left mb-3">
												<Label>
													Financing Subtype
												</Label>
												<Input
													type="select"
													name="financingSubtype"
													className={financingSubtype ? "" : ' select__placeholder'}
													value={financingSubtype || ''}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value={"retailFiling"}>Retail Filing</option>
													<option value={"developerAssisted"}>Developer Assisted</option>
												</Input>
											</FormGroup>
											<FormGroup check className="text-left mb-3">
												<Label>
													Status
												</Label>
												<Input
													type="select"
													name="status"
													className={status ? "" : ' select__placeholder'}
													value={status || ''}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value='available'>Available</option>
													<option value='reserved'>Reserved</option>
													<option value='active'>Active</option>
													<option value='fullyPaid'>Fully Paid</option>
													<option value='completed'>Completed</option>
													<option value='canceled'>Canceled</option>
												</Input>
											</FormGroup>
											{
												status === 'Canceled' ? <FormGroup>
													<Label>Refund Amount</Label>
													<CurrencyInput 
														name="refund_amount"
														price={refund_amount || 0}
														onChange={(value) => this.onChangeField({ target: { name: "refund_amount", value } })}
														placeholder="Refund Amount"
													/>
												</FormGroup> : null
											}
											<FormGroup check className="text-left mb-3">
												<Label>
													Attorney-in-fact
												</Label>
												<Input
													type="select"
													name="attorneyInFact"
													className={attorneyInFact ? "" : ' select__placeholder'}
													value={attorneyInFact || ''}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value='Yes'>Yes</option>
													<option value='No'>No</option>
												</Input>
											</FormGroup>
											{attorneyInFact === 'Yes' ? <PersonalInformationCard 
												attribute="attorney"
												title="Attorney In Fact"
												data={attorney}
												onChangeField={this.onChangeField}
											/> : null}
											<FormGroup check className="text-left mb-3">
												<Label>
													Has Co-Borrowers
												</Label>
												<Input
													type="select"
													name="hasCoBorrower"
													className={hasCoBorrower ? "" : ' select__placeholder'}
													value={hasCoBorrower || ''}
													onChange={this.onChangeField}
												>
													<option value=''>--SELECT--</option>
													<option value='Yes'>Yes</option>
													<option value='No'>No</option>
												</Input>
											</FormGroup>
											{hasCoBorrower === 'Yes' ? <>
												<Card className="detail-card">
													<CardHeader>
														<h3 className="mb-0">Co-Borrowers <i role="button" onClick={this.addCoBorrower} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
													</CardHeader>
													<CardBody>
														{
															coBorrowers.map(({coBorrower, coBorrowerOccupation}, index) => {
																return (
																	<Fragment key={index}>
																		<PersonalInformationCard 
																			attribute="coBorrower"
																			title={<span>{`Co-Borrower ${index + 1} Details`} <i onClick={this.deleteCoborrower(index)} className="tim-icons icon-trash-simple cursor-pointer pull-right" style={{fontSize: 16}} /></span>}
																			data={coBorrower}
																			onChangeField={this.onChangeCoBorrowerField('coBorrower', index)}
																			className="coborrower-card"
																		/>
																		<WorkAndOccupationCard 
																			title={`Co-Borrower ${index + 1} Work and Occupation`}
																			onChangeField={this.onChangeCoBorrowerField('coBorrowerOccupation', index)}
																			data={coBorrowerOccupation}
																			className="coborrower-card"
																		/>
																	</Fragment>
																)
															})
														}
													</CardBody>
												</Card>
											</> : null}
											{civil_status === 'Married' ? <>
												<PersonalInformationCard 
													attribute="spouse"
													title="Spouse Information"
													data={spouse}
													onChangeField={this.onChangeField}
												/>
												<WorkAndOccupationCard 
													title="Spouse Work and Occupation"
													onChangeField={this.onChangeSpouseField}
													data={spouseOccupation}
												/>
											</> : null}
											<Row>
												<Col sm={12}>
													<FormGroup>
														<Label>Seller <span className="required-start">*</span></Label>
														<Async
															value={selectedSeller}
															name="selectedSeller"
															options={[]}
															loadOptions={this.loadSellers}
															className="basic-multi-select"
															classNamePrefix="select"
															onChange={this.onSelectChange('selectedSeller')}
															placeholder="Search seller by name or email"
														/>
													</FormGroup>
												</Col>
											</Row>
											{_id ? <><FormGroup>
												<Label>Created At</Label>
												<Input
													type="text"
													name="created_at"
													value={getFormattedDate(created_at || '')}
													readOnly
												/>
											</FormGroup>
												<FormGroup>
													<Label>Updated At</Label>
													<Input
														type="text"
														name="updated_at"
														value={getFormattedDate(updated_at || '')}
														readOnly
													/>
												</FormGroup>
											</> : null}
										</>
									}
									{error ? <div className="alert alert-danger mt-3">
											<span>{error}</span>
										</div> : null
									}
								</CardBody>
								{client ? <Col>
									<Button color="primary" block={false} className="mb-4" onClick={this.save} disabled={saving}>
										{saving
											? "Saving..."
											: _id
												? "Save Changes"
												: "Save Client"
										}
									</Button>
								</Col> : null}
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

const PersonalInformationCard = ({ onChangeField, data, attribute, title, className }) => {
	
	const onChange = (event) => {
		const { name, value } = event.target;
		const updatedData = { ...data }
		updatedData[name] = value;
		onChangeField({target: { name: attribute, value: updatedData}});
	}

	const {
		first_name,
		last_name,
		middle_name,
		gender,
		birthday,
		age,
		nationality,
		address,
		email,
		phone
	} = data || {};
	
	return (
		<Card className={`detail-card ${className}`}>
			<CardHeader>
				<h3>{title}</h3>
			</CardHeader>
			<CardBody>
				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>First Name</Label>
							<Input
								type="text"
								name="first_name"
								value={first_name || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Last Name</Label>
							<Input
								type="text"
								name="last_name"
								value={last_name || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Middle Name</Label>
							<Input
								type="text"
								name="middle_name"
								value={middle_name || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>														
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Gender</Label>
							<Input
								type="select"
								name="gender"
								className={gender ? "" : ' select__placeholder'}
								value={gender || ''}
								onChange={onChange}
							>
								<option value=''>--SELECT--</option>
								<option value='Male'>Male</option>
								<option value='Female'>Female</option>
							</Input>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Birthday</Label>
							<Datetime
								inputProps={{
									className: "form-control",
									placeholder: "Birthday",
									name: "birthday"
								}}
								dateFormat="MM/DD/YYYY"
								timeFormat={false}
								value={typeof birthday === 'string' ? moment(birthday).format("MM/DD/YYYY") : birthday}
								onChange={(date) => onChange({target: { value: moment(date).format("MM/DD/YYYY"), name: "birthday" }})}
								closeOnSelect={true}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Age</Label>
							<Input
								type="text"
								name="age"
								value={age || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Nationality</Label>
							<Input
								type="text"
								name="nationality"
								value={nationality || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Home Address</Label>
							<Input
								type="text"
								name="address"
								value={address || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
				</Row>

				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Email Address</Label>
							<Input
								type="text"
								name="email"
								value={email || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Contact Numbers/Mobile</Label>
							<Input
								type="text"
								name="phone"
								value={phone || ''}
								onChange={onChange}
							/>
						</FormGroup>
					</Col>
				</Row>
			</CardBody>
		</Card>
	)
}

const WorkAndOccupationCard = ({ onChangeField, data={}, title, className='' }) => {
	const {
		occupation,
		companyName,
		companyAddress,
		companyContact,
		companyEmail,
		businessNature,
		jobTitle,
		experience
	} = data;

	return (

		<Card className={`detail-card ${className}`}>
			<CardHeader>
				<h3>{title}</h3>
			</CardHeader>
			<CardBody>
				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Occupation</Label>
							<Input
								type="select"
								name="occupation"
								value={occupation || ''}
								className={occupation ? "" : ' select__placeholder'}
								onChange={onChangeField}
							>
								<option value=''>--SELECT--</option>
								<option value="Own Business">Own Business</option>
								<option value="Private">Private</option>
								<option value="Retiree/Pensioner">Retiree/Pensioner</option>
								<option value="Housewife">Housewife</option>
								<option value="Government">Government</option>
								<option value="OFW">OFW</option>
								<option value="Others">Others</option>
							</Input>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Business/Company Name</Label>
							<Input
								type="text"
								name="companyName"
								value={companyName || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Company Address</Label>
							<Input
								type="text"
								name="companyAddress"
								value={companyAddress || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Contact Number/Mobile</Label>
							<Input
								type="text"
								name="companyContact"
								value={companyContact || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Company Email Address</Label>
							<Input
								type="text"
								name="companyEmail"
								value={companyEmail || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Nature of Business</Label>
							<Input
								type="text"
								name="businessNature"
								value={businessNature || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Position Held</Label>
							<Input
								type="text"
								name="jobTitle"
								value={jobTitle || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
					<Col sm={12} md={6}>
						<FormGroup>
							<Label>Years in Employment</Label>
							<Input
								type="text"
								name="experience"
								value={experience || ''}
								onChange={onChangeField}
							/>
						</FormGroup>
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
}

export default ClientForm;
